import React, { useState } from "react";
import { Box, Container, Typography, Button } from "@mui/material";

import LoginFooter from "./LoginFooter";
import LoginCard from "../../Componenets/Login/LoginCard";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [isLogin, setIsLogin] = useState(true);
const navigate = useNavigate();
  return (
    <Box minHeight="100vh" bgcolor="#FFF">
      <Box
      mt={10}
        sx={{
          bgcolor: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          component="img"
          src="/Images/header-logo.png"
          alt="Logo"
          sx={{
            height: 50,
            cursor: "pointer",
          }}
            onClick={() => navigate("/")}
        />
      </Box>
      <LoginCard />

      <LoginFooter />
    </Box>
  );
};

export default Login;
